import React from 'react';
import { UserRound, Image as ImageIcon, X } from 'lucide-react';
import ModalOverlay from '../ui/ModalOverlay';

export type EditorImagePurpose = 'avatar' | 'photo';

type Props = {
  open: boolean;
  preview?: string;
  label?: string;
  remaining?: number;
  onPick: (purpose: EditorImagePurpose) => void;
  onClose: () => void;
};

export default function EditorImagePurposeModal({
  open,
  preview,
  label,
  remaining = 0,
  onPick,
  onClose,
}: Props) {
  if (!open) return null;

  return (
    <ModalOverlay onClose={onClose} closeOnBackdrop={false} style={{ zIndex: 10050 }}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 400, width: 'min(400px, calc(100vw - 32px))' }}
      >
        <div className="modal-header">
          <h2 style={{ fontSize: '1.05rem' }}>Como usar esta imagem?</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        {preview && (
          <img
            src={preview}
            alt={label || 'Imagem'}
            style={{
              width: '100%',
              height: 160,
              objectFit: 'cover',
              borderRadius: 10,
              marginBottom: 12,
              display: 'block',
            }}
          />
        )}
        <p style={{ margin: '0 0 14px', fontSize: '0.78rem', color: 'rgba(255,255,255,0.62)', lineHeight: 1.45 }}>
          {label ? `${label}. ` : ''}
          Avatar = retrato para a pessoa falar. Foto = referência da cena (imóvel, produto, lugar).
          {remaining > 1 ? ` Faltam ${remaining - 1} depois desta.` : ''}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <button
            type="button"
            onClick={() => onPick('avatar')}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              textAlign: 'left',
              border: '1px solid rgba(244,114,182,0.35)',
              borderRadius: 10,
              background: 'rgba(244,114,182,0.12)',
              color: '#fff',
              padding: '10px 12px',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <UserRound size={18} style={{ marginTop: 2, color: '#f9a8d4', flexShrink: 0 }} />
            <span>
              <strong style={{ display: 'block', fontSize: '0.82rem' }}>Avatar</strong>
              <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.62)' }}>
                Rosto visível para locução / Kling Avatar
              </span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => onPick('photo')}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              textAlign: 'left',
              border: '1px solid rgba(129,140,248,0.35)',
              borderRadius: 10,
              background: 'rgba(99,102,241,0.14)',
              color: '#fff',
              padding: '10px 12px',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <ImageIcon size={18} style={{ marginTop: 2, color: '#a5b4fc', flexShrink: 0 }} />
            <span>
              <strong style={{ display: 'block', fontSize: '0.82rem' }}>Foto</strong>
              <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.62)' }}>
                Referência da cena — Seedance, imóvel, produto
              </span>
            </span>
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
